export default function (value) {
  if (!value) return value;
  return `+${value.substring(0, 2)} (${value.substring(2, 4)}) ${value.substring(4, 9)}-${value.substring(9, 15)}`;
}
